export const LOGIN_URL = "/login";

export const DASHBOARD_URL = "/dashboard";
